{
	"title": "Vytvořit prohlášení",
	"backLinkToMaterialDetailsTitle": "Zpět na podrobnosti o materiálu",
	"backLinkToMaterialDetailsWithDescriptionTitle": "Zpět na {{materialDescription}}",
	"backLinkToManageDeclarationsTitle": "Zpět na Správa prohlášení",
	"steps": {
		"firstStep": {
			"title": "Krok 1",
			"label": "1"
		},
		"secondStep": {
			"title": "Krok 2",
			"label": "2"
		},
		"thirdStep": {
			"title": "Krok 3",
			"label": "3"
		}
	}
}
